const initialState = {
  isLoading: false,
  data: {},
};

export const logReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_STATE":
      return {
        ...state,
        isLoading: true,
      };

    case "GET_SUCCESS":
      return {
        ...state,
        isLoading: false,
        data: action.payload,
      };

    default:
      return state;
  }
};
